import { Grid, Typography } from '@mui/material';
import NoPhotographyIcon from '@mui/icons-material/NoPhotographyOutlined';
import { Event } from '../../model/event';
import { EventDay } from '../../model/event-day';
import CameraCard from './CameraCard';
import styles from './LinkedCameras.module.css';
import CollapseBar from '../commons/CollapseBar';
import { toSlashedDate } from '../../app/helper/dateFormatHelper';
import { Camera } from '../../model/camera';

interface IPictureDayProps {
  day: EventDay;
  number: number;
  userCanDeleteCamera: boolean;
  groupPicturesExpected: boolean;
  onDeleteCamera: (camera: Camera) => void;
}

function PictureDay({
  day,
  number,
  userCanDeleteCamera,
  onDeleteCamera,
  groupPicturesExpected
}: IPictureDayProps) {
  const formattedDate = toSlashedDate(day.date || '');
  const formattedLastDate = toSlashedDate(day.lastDate || '');
  const isMultiday = day.lastDate && day.date !== day.lastDate;
  return (
    <div>
      <CollapseBar
        defaultCollapsed={false}
        title={
          <Typography variant='h4'>
            {isMultiday
              ? `Multiday ${formattedDate} - ${formattedLastDate}`
              : `Day ${number} - ${formattedDate}`}
          </Typography>
        }
      >
        <Grid container columnSpacing={6}>
          {day.cameras?.map((camera) => (
            <Grid
              item
              xs={12}
              md={4}
              key={`${camera.cameraId}-${camera.mediaId}`}
            >
              <CameraCard
                camera={camera}
                date={formattedDate}
                userCanDelete={userCanDeleteCamera}
                onDeleteCamera={onDeleteCamera}
                groupPicturesExpected={groupPicturesExpected}
              />
            </Grid>
          ))}
        </Grid>
      </CollapseBar>
    </div>
  );
}

interface ILinkedCamerasProps {
  eventDetails?: Event;
  userCanDeleteCamera: boolean;
  onDeleteCamera: (camera: Camera) => void;
}

function LinkedCameras({
  eventDetails,
  userCanDeleteCamera,
  onDeleteCamera,
}: ILinkedCamerasProps) {
  return (
    <div className={styles.linkedCameras}>
      <Typography variant='h6' color='primary.dark' align='left'>
        Linked Cameras
      </Typography>
      {eventDetails?.days?.map((day, i, days) => (
        <PictureDay
          key={`${day.date}-${day.lastDate}`}
          day={day}
          number={1 + days.slice(1, i + 1).filter((d, j) => d.date !== days[j].date).length}
          userCanDeleteCamera={userCanDeleteCamera}
          onDeleteCamera={onDeleteCamera}
          groupPicturesExpected={!!eventDetails.groupPicturesExpected}
        />
      )) || (
        <div className={styles.noCameras}>
          <NoPhotographyIcon /> No cameras linked! Cameras will not appear until
          an image is uploaded.
        </div>
      )}
    </div>
  );
}

export default LinkedCameras;
